<template>
  <b-form-row>
    <b-modal
      size="xl"
      button-size="sm"
      :id="id"
      ref="finder"
      hide-footer
      :title="title"
    >
      <TipoBaixaList
        @onDblClickTipoBaixa="tipoBaixaSelect"
        :isModal="isModal"
        :prefix="updatedPrefix"
      />
    </b-modal>
    <lg-form-input-finder
      :value="computedValue"
      @input="updateValue"
      fieldDescription="descricao"
      :label="label"
      invalidFeedback="Tipo de Baixa deve ser informado!"
      description=""
      :disabled="disabled"
      @clear="handleClean"
    >
      <template #prepend>
        <b-button @click="show" class="btn-input-finder" pressed :disabled="disabled">
          <b-icon icon="search" />
        </b-button>
      </template>
    </lg-form-input-finder>
  </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";
import TipoBaixaList from "@/modules/cadastros/tipo-baixa/TipoBaixaList.vue";

export default {
  name: "LgFinderPageTipoBaixa",
  components: {
    LgFormInputFinder,
    TipoBaixaList
  },
  props: {
    id: {
      type: String,
      required: true
    },
    onSelect: {
      type: Function
    },
    onClear: {
      type: Function
    },
    value: {
      type: [Object, String],
      default: () => ({})
    },
    isModal: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    prefix: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: "Tipo de Baixa:"
    }
  },
  data() {
    return {
      internalValue: this.value || {}
    };
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal;
    }
  },
  computed: {
    computedValue: {
      get() {
        return this.internalValue;
      },
      set(newVal) {
        this.internalValue = newVal;
      }
    },
    updatedPrefix() {
      return [...this.prefix, "Tipo de Baixa"];
    },
    title() {
      return this.updatedPrefix.join(" > ");
    }
  },
  methods: {
    async show() {
      await this.$refs.finder.show();
    },
    updateValue(newValue) {
      this.computedValue = newValue;
      this.$emit("input", newValue);
    },
    handleClean() {
      this.computedValue = {};
      this.$emit("input", {});
    },
    async tipoBaixaSelect(item) {
      this.computedValue = item;
      this.$emit("input", item);
      this.$bvModal.hide(this.id);
    }
  }
};
</script>

<style scoped>
</style>
